import React, { useState } from "react";

import adp from "../../../assets/EMP_FeaturedIntegrationPartners/adp-platinum-partner-logo.webp";
import workday from "../../../assets/EMP_FeaturedIntegrationPartners/dailypay-workday-logo.webp";
import infor from "../../../assets/EMP_FeaturedIntegrationPartners/infor-partner-logo.png.webp";
import infosync from "../../../assets/EMP_FeaturedIntegrationPartners/infosync-partner-logo.png.webp";
import isolved from "../../../assets/EMP_FeaturedIntegrationPartners/Isolved-logo.webp";
import alight from "../../../assets/EMP_FeaturedIntegrationPartners/market-place-alight.png.webp";
import epay from "../../../assets/EMP_FeaturedIntegrationPartners/market-place-epay.png.webp";
import hha from "../../../assets/EMP_FeaturedIntegrationPartners/market-place-hha-exchange.png.webp";
import paycor from "../../../assets/EMP_FeaturedIntegrationPartners/market-place-paycor.png.webp";
import ukg from "../../../assets/EMP_FeaturedIntegrationPartners/market-place-ukg.png.webp";
import viventium from "../../../assets/EMP_FeaturedIntegrationPartners/market-place-viventium.png.webp";
import oracle from "../../../assets/EMP_FeaturedIntegrationPartners/oracle-partner-logos.png.webp";
import par from "../../../assets/EMP_FeaturedIntegrationPartners/par-logo.webp";
import paychex from "../../../assets/EMP_FeaturedIntegrationPartners/paychex-logo.png.webp";
import payday from "../../../assets/EMP_FeaturedIntegrationPartners/payday-portal-logo.png.webp";
import paylocity from "../../../assets/EMP_FeaturedIntegrationPartners/paylocity-logo.png.webp";
import quinyx from "../../../assets/EMP_FeaturedIntegrationPartners/quinyx_logo_petrolium_CMYK-2-1.png.webp";
import sap from "../../../assets/EMP_FeaturedIntegrationPartners/sap-partner-logo.png.webp";
import smartlinx from "../../../assets/EMP_FeaturedIntegrationPartners/smartlinx-partner-logo.png.webp";
import teamsoftware from "../../../assets/EMP_FeaturedIntegrationPartners/team-software-partner-logo.png.webp";
import webclock from "../../../assets/EMP_FeaturedIntegrationPartners/webclock-partner-logo.png.webp";
import wurk from "../../../assets/EMP_FeaturedIntegrationPartners/wurk-logo-1.webp";

const integrations = [
  {
  id: 1,
  logo: adp,
  title: "ADP Marketplace",
  description:
    "Industry-leading payroll and HR solutions covering tax, compliance, and benefit admin.",

  expandable: true,

  timekeeping: [
    "ADP Enterprise Enhanced Time",
    "ADP Essential Time",
    "ADP Time & Attendance",
    "ADP TimeSaver",
    "ADP WorkforceManager",
  ],

  payroll: [
    "ADP Enterprise (EV5)",
    "ADP Enterprise (EV6)",
    "ADP Next Gen",
    "ADP Payforce",
    "ADP RUN",
    "ADP TotalSource",
  ],
},
  {
    id: 2,
    logo: workday,
    title: "Workday",
    description:
      "Enterprise AI platform providing essential solutions for finance, HR, planning, and spend management.",
  },
  {
  id: 3,
  logo: ukg,
  title: "UKG",
  description:
    "Leading HR, payroll, and workforce management solutions.",
  expandable: true,

  timekeeping: [
    "Kronos iSeries",
    "Kronos Workforce Central",
    "Kronos Workforce Dim-NovaTime-PeopleNet",
    "Kronos Workforce Dimensions",
    "UKG Ready",
  ],

  payroll: [
    "UKG Pro",
    "UKG Ready",
    "Kronos Workforce Central V8",
    "Kronos Workforce Dimensions",
    "Ascentis",
  ],
},
  {
    id: 4,
    logo: paylocity,
    title: "Paylocity",
    description:
      "Cloud-based HR and payroll software that streamlines processes and helps build employee culture.",
  },
  {
    id: 5,
    logo: paycor,
    title: "Paycor",
    description:
      "Modern HR software that saves leaders time and provides powerful analytics for people management.",
  },
  {
    id: 6,
    logo: paychex,
    title: "Paychex",
    description:
      "Industry-leading HCM providing advisory services in HR, employee benefits, insurance, and payroll.",
  },
  {
    id: 7,
    logo: sap,
    title: "SAP",
    description:
      "Global leader in business cloud software helping organizations run better worldwide.",
  },
  {
    id: 8,
    logo: oracle,
    title: "Oracle",
    description:
      "Offers a comprehensive and fully integrated stack of cloud applications and platform services.",
  },
  {
    id: 9,
    logo: alight,
    title: "Alight",
    description:
      "Connects insights across people, work, and life to unlock enterprise growth.",
  },
  {
    id: 10,
    logo: epay,
    title: "EPAY",
    description:
      "The only complete HR and payroll software solution designed for employers with a distributed workforce.",
  },
  {
    id: 11,
    special: true,
    title: "Interested in partnering with DailyPay?",
    description:
      "Learn more about how we partner with HCM, workforce management, or bank & financial institution.",
    buttonText: "Partner With Us",
  },
  {
    id: 12,
    logo: payday,
    title: "Gratuity Solutions",
    description:
      "Platform eliminating manual processes to collect and move data between systems to calculate earnings and process payroll.",
  },
  {
    id: 13,
    logo: hha,
    title: "HHAeXchange",
    description:
      "Homecare software solution connecting providers, state Medicaid programs, managed care organizations, and caregivers.",
  },
  {
    id: 14,
    logo: infor,
    title: "Infor",
    description:
      "Global leader in business cloud software products for companies in industry-specific markets.",
  },
  {
    id: 15,
    logo: infosync,
    title: "Infosync",
    description:
      "Accounting, payroll, and reporting services paired with expert business insights.",
  },
  {
    id: 16,
    logo: isolved,
    title: "isolved",
    description:
      "Provider of HCM solutions that help organizations recruit, retain, and elevate their workforce.",
  },
  {
    id: 17,
    special: true,
    title: "Can’t find the integration you’re looking for?",
    description:
      "If your system is bespoke or you still need help, connect with our team to explore solutions.",
    buttonText: "Connect With Our Team",
  },
  {
    id: 18,
    logo: par,
    title: "PAR Technology",
    description:
      "Leading foodservice solution bringing POS, ordering, loyalty, payments, and operations into one unified system.",
  },
  {
    id: 19,
    logo: quinyx,
    title: "Quinyx",
    description:
      "Leverages AI forecasting for optimized and fair scheduling, streamlined time reporting, task management, and communication.",
  },
  {
    id: 20,
    logo: smartlinx,
    title: "SmartLinx",
    description:
      "Workforce Healthcare Platform that radically simplifies management of the healthcare workforce.",
  },
  {
    id: 21,
    logo: teamsoftware,
    title: "Team Software",
    description:
      "Market-leading workforce management software and back-office solutions for cleaning, security, and facilities companies.",
  },
  {
    id: 22,
    logo: viventium,
    title: "Viventium",
    description:
      "SaaS-based human capital management solution that provides a remarkable user experience.",
  },
  {
    id: 23,
    logo: webclock,
    title: "WebClock",
    description:
      "ITCS WebClock: Web based time and attendance software that streamlines workforce management.",
  },
  {
    id: 24,
    logo: wurk,
    title: "Würk",
    description:
      "Allows cannabis companies to manage payroll, human resources, timekeeping, scheduling, and tax regulation.",
  },
];

const ITEMS_PER_LOAD = 8;

const FeaturedIntegrationPartners = () => {
    const [openCard, setOpenCard] = useState(null);

  const [visibleCount, setVisibleCount] = useState(8);

  const visibleCards = integrations.slice(0, visibleCount);

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + ITEMS_PER_LOAD);
  };

  return (
   <section
  className="w-full bg-white py-16 lg:py-20"
  id="featured-integrations"
>
  <div className="max-w-7xl mx-auto px-5 lg:px-8">

    {/* HEADING */}
    <div className="text-center mb-14">
      <h2 className="text-[42px] sm:text-[54px] lg:text-[42px] leading-[1.1] font-serif font-light text-[#2b0902] mb-6">
        Featured integrations partners
      </h2>

      <p className="text-[18px] lg:text-[16px] font-light leading-8 lg:leading-6 max-w-[760px] mx-auto text-[#1e1c1c]">
        We integrate seamlessly with the leading HCM and payroll providers
        you already use. Our{" "}
        <br className="hidden sm:block" />
        pre-built connectors mean zero disruption and a smooth launch
        experience.
      </p>
    </div>

    {/* SEARCH */}
    <div className="max-w-3xl mx-auto mb-14">
      <div className="border border-[#d8d0ca] rounded-full bg-white px-6 py-4 lg:px-4 lg:py-1 flex items-center justify-between">
        <input
          type="text"
          placeholder='Search by company name, service or product. Try “ADP” or “ADP Essential Time”'
          className="w-full outline-none bg-transparent text-[17px] lg:text-[15px]"
        />

<span className="text-[20px] lg:text-[30px] rotate-[270deg] inline-block">
  ⌕
</span>      
</div>
    </div>

   {/* GRID */}
<div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">

  {visibleCards.map((item, index) => {

    // HIDE NEXT CARD WHEN CURRENT CARD EXPANDS
    if (
      openCard &&
      index === visibleCards.findIndex((x) => x.id === openCard) + 1
    ) {
      return null;
    }

    return (

      <React.Fragment key={item.id}>

        {/* NORMAL CARD */}
        {openCard !== item.id && (

          <div
            className={`border border-[#ddd6cf] p-5 h-[430px] flex flex-col ${
              item.special ? "bg-[#efe2d7]" : "bg-white"
            }`}
          >

            {/* LOGO */}
            {!item.special && (
              <div className="h-[80px] flex items-start mb-8 lg:mt-[15px]">
                <img
                  src={item.logo}
                  alt={item.title}
                  className="max-w-[140px] max-h-[60px] object-contain scale-[1.08]"
                />
              </div>
            )}

            {/* SPECIAL SPACING */}
            {item.special && <div className="h-[20px]" />}

            {/* TITLE */}
            <h3 className="text-[18px] lg:text-[20px] font-black lg:tracking-[-1px] text-[#1d0600] mb-4 lg:-mt-[30px]">
              {item.title}
            </h3>

            {/* DESCRIPTION */}
            <p
              className={`text-[#222] ${
                item.special
                  ? "text-[18px] lg:text-[16px] leading-[1.7]"
                  : "text-[17px] lg:text-[14px] lg:font-semibold leading-[1.7] lg:leading-[1.6]"
              }`}
            >
              {item.description}
            </p>

            {/* TAGS */}
            {!item.special && (
<div
  className={`flex gap-2 flex-wrap ${
    item.id >= 4 ? "mt-[110px]" : "mt-auto pt-7"
  }`}
>
                <span className="border border-[#d8d0ca] px-4 lg:px-3 py-2 lg:py-2 text-[12px] lg:text-[11px] bg-[#faf7f5] leading-none">
                  Timekeeping
                </span>

                <span className="border border-[#d8d0ca] px-4 lg:px-3 py-2 lg:py-2 text-[12px] lg:text-[11px] bg-[#faf7f5] leading-none">
                  Payroll
                </span>

              </div>
            )}

            {/* SPECIAL BUTTON */}
            {item.special && (
              <button className="mt-auto border-2 border-[#2d0902] text-[#2d0902] px-6 py-3 text-[18px] font-semibold hover:bg-[#2d0902] hover:text-white transition w-fit">
                {item.buttonText}
              </button>
            )}

            {/* SEE MORE BUTTON */}
            {!item.special && (
              <>
                {item.title === "Workday" ? (
                  <button
                    className="
                      mt-5
                      ml-auto
                      text-[18px]
                      lg:text-[16px]
                      font-semibold
                      flex
                      items-center
                      gap-2
                      text-[#1d0600]
                      hover:opacity-70
                      transition
                    "
                  >
                    Workday partnership

                    <span className="text-[22px] leading-none">
                      →
                    </span>
                  </button>
                ) : (
                  item.expandable && (
                    <button
                      onClick={() => {
                        setOpenCard(item.id);

                        setTimeout(() => {
                          document
                            .getElementById(`expanded-${item.id}`)
                            ?.scrollIntoView({
                              behavior: "smooth",
                              block: "center",
                            });
                        }, 100);
                      }}
                      className="
                        mt-5
                        ml-auto
                        text-[18px]
                        lg:text-[16px]
                        font-semibold
                        flex
                        items-center
                        gap-2
                        text-[#1d0600]
                        hover:opacity-70
                        transition
                      "
                    >
                      See More

                      <span className="text-[22px] leading-none">
                        +
                      </span>
                    </button>
                  )
                )}
              </>
            )}
          </div>
        )}

        {/* EXPANDED CARD */}
        {openCard === item.id && (

          <div
            id={`expanded-${item.id}`}
            className="
              border
              border-[#ddd6cf]
              bg-[#fafafa]
              flex
              h-[420px]
              relative
              sm:col-span-2
            "
          >

            {/* LEFT SIDE */}
            <div className="w-[48%] bg-white p-6 flex flex-col">

              {/* LOGO */}
              <div className="h-[80px] flex items-start mb-8">
                <img
                  src={item.logo}
                  alt={item.title}
                  className="max-w-[150px] max-h-[70px] object-contain"
                />
              </div>

              {/* TITLE */}
              <h3 className="text-[22px] font-black text-[#1d0600] mb-5">
                {item.title}
              </h3>

              {/* DESCRIPTION */}
              <p className="text-[18px] leading-[1.6] text-[#222]">
                {item.description}
              </p>

              {/* TAGS */}
              <div className="flex gap-2 flex-wrap mt-auto pt-6">

                <span className="border border-[#d8d0ca] px-4 py-3 text-[14px] bg-[#faf7f5]">
                  Timekeeping
                </span>

                <span className="border border-[#d8d0ca] px-4 py-3 text-[14px] bg-[#faf7f5]">
                  Payroll
                </span>

              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="w-[52%] p-8 relative">

              {/* VERTICAL LINE */}
              <div className="absolute left-0 top-10 bottom-10 border-l border-dashed border-[#bdb5ae]"></div>

              {/* TIMEKEEPING */}
              <h4 className="text-[18px] lg:text-[14px] font-black text-[#667085] mb-4 lg:mb-3">
                TIMEKEEPING
              </h4>

              <ul className="list-disc pl-6 mb-10 space-y-2 text-[16px] lg:text-[14px] leading-[1.5] lg:leading-[0.8]">
                {item.timekeeping?.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
              </ul>

              {/* PAYROLL */}
              <h4 className="text-[18px] lg:text-[14px] font-black text-[#667085] mb-4 lg:mb-3">
                PAYROLL
              </h4>

              <ul className="list-disc pl-6 space-y-2 lg:space-y-2 text-[16px] lg:text-[14px] leading-[1.5] lg:leading-[0.8]">
                {item.payroll?.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
              </ul>

              {/* CLOSE BUTTON */}
              <button
                onClick={() => setOpenCard(null)}
                className="
                  absolute
                  bottom-6
                  right-6
                  text-[18px]
                  text-[#1d0600]
                  flex
                  items-center
                  gap-2
                  hover:opacity-70
                  lg:text-[14px]
                "
              >
                Close

                <span className="text-[24px] lg:text-[20px] leading-none">
                  ×
                </span>
              </button>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  })}
</div>

    {/* LOAD MORE */}
    {visibleCount < integrations.length && (
      <div className="flex justify-center mt-14">
        <button
          onClick={handleLoadMore}
          className="text-[18px] lg:text-[16px] font-semibold flex items-center gap-2 hover:opacity-70 transition text-black"
        >
          <span className="text-[26px] lg:-mt-[20px]">
            ⌄
          </span>

          More integration partners
        </button>
      </div>
    )}

  </div>
</section>
  );
};

export default FeaturedIntegrationPartners;